<form *transloco="let t; prefix: 'uiKit'" [formGroup]="form" class="form w-100">
  <div class="fv-row mb-5">
    <ui-form-label required>{{ t('form.oldPassword') }}</ui-form-label>
    <ui-form-password
      [control]="form.controls['oldPassword']"
      [type]="'password'"
      [placeholder]="t('placeholders.oldPassword')"
    ></ui-form-password>
  </div>
  <div class="fv-row mb-5">
    <ui-form-label required>{{ t('form.newPassword') }}</ui-form-label>
    <ui-form-password
      [control]="form.controls['password']"
      [type]="'password'"
      [placeholder]="t('placeholders.newPassword')"
    ></ui-form-password>
  </div>
  <div class="fv-row mb-7">
    <ui-form-label required>{{ t('form.confirmPassword') }}</ui-form-label>
    <ui-form-password
      [control]="form.controls['confirmPassword']"
      [type]="'password'"
      [placeholder]="t('placeholders.confirmPassword')"
    ></ui-form-password>
  </div>
  <div class="modal-footer">
    <ui-button
      [btnClass]="'btn'"
      [severity]="'warning'"
      [buttonText]="t('buttons.cancel')"
      (click)="form.reset()"
    ></ui-button>
    <ui-button
      [disabled]="form.invalid"
      [isLoading]="isLoading()"
      [buttonText]="t('buttons.confirm')"
      (click)="submit()"
    ></ui-button>
  </div>
</form>
